export const DEFAULT = "DEFAULT";
export const CELEBRATION = "CELEBRATION";
export const DROPOFF = "DROPOFF";
export const PICKUP = "PICKUP";
export const TEAM = "TEAM";
export const TRASH = "TRASH";
export const COLLECTED = "COLLECTED";
